module.exports = __webpack_public_path__ + "static/img/6.8bf20fc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/4/sp/6.png
// module id = U/x/
// module chunks = 0